<template>
  <li class="card-item">
    <h4 class="name">{{ name }}</h4>
    <p class="desc">{{ desc }}</p>

    <div class="liking">
      <button @click="disliked" class="dislike" :class="{ active: dislike }" :disabled="dislike || like">
        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M.6 8.84C.211 9.344 0 10 0 10.803c0 1.472 1.253 2.835 2.84 2.835h2.741c-.34.678-.808 1.52-.808 2.727 0 2.282.91 3.636 3.238 3.636 1.172 0 1.607-1.481 1.83-2.626.133-.684.258-1.33.645-1.717.92-.92 2.326-3.157 3.171-3.611.085-.036.195-.064.314-.087.225.327.602.541 1.029.541h3.75c.69 0 1.25-.56 1.25-1.25v-10C20 .56 19.44 0 18.75 0H15c-.69 0-1.25.56-1.25 1.25v.341C12.48 1.591 9.817 0 6.818.001c-.215 0-1.47-.002-1.602 0C2.9 0 1.612 1.402 1.687 3.508A3.243 3.243 0 0 0 .975 6.13C.49 6.892.385 7.97.6 8.841zm18.15-7.59v10H15v-10h3.75zM2.187 9.205c-.624-.455-.624-2.33.219-2.76-.528-.89-.053-2.08.586-2.422-.324-2.052.741-2.758 2.235-2.772.13-.002 1.455 0 1.591 0 2.849 0 5.263 1.59 6.932 1.59v7.955c-1.473 0-2.824 2.654-4.148 3.977-1.193 1.193-.795 3.182-1.59 3.977-1.99 0-1.99-1.387-1.99-2.386 0-1.648 1.194-2.386 1.194-3.977H2.84c-.888 0-1.587-.796-1.591-1.591-.004-.796.313-1.421.937-1.591zm13.75-6.08a.937.937 0 1 1 1.875 0 .937.937 0 0 1-1.875 0z" fill="#9B9B9B" fill-rule="evenodd"/></svg>
      </button>
      <button @click="liked" class="like" :class="{ active: like }" :disabled="dislike || like">
        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M19.4 11.16c.388-.503.6-1.16.6-1.962 0-1.472-1.253-2.835-2.84-2.835h-2.741c.34-.678.808-1.52.808-2.727 0-2.282-.91-3.636-3.238-3.636-1.172 0-1.607 1.481-1.83 2.626-.133.684-.258 1.33-.645 1.717-.92.92-2.326 3.157-3.171 3.611a1.603 1.603 0 0 1-.314.087A1.248 1.248 0 0 0 5 7.5H1.25C.56 7.5 0 8.06 0 8.75v10C0 19.44.56 20 1.25 20H5c.69 0 1.25-.56 1.25-1.25v-.341c1.27 0 3.933 1.591 6.932 1.59.215 0 1.47.002 1.602 0 2.316.001 3.604-1.401 3.529-3.507.59-.693.88-1.693.712-2.621.486-.763.59-1.839.376-2.712zM1.25 18.75v-10H5v10H1.25zm16.563-7.955c.625.455.625 2.33-.219 2.76.528.89.053 2.08-.586 2.422.324 2.052-.741 2.758-2.235 2.772-.13.002-1.455 0-1.591 0-2.849 0-5.263-1.59-6.932-1.59V9.204c1.473 0 2.824-2.654 4.148-3.977 1.193-1.193.795-3.182 1.59-3.977 1.99 0 1.99 1.387 1.99 2.386 0 1.648-1.194 2.386-1.194 3.977h4.375c.888 0 1.587.796 1.591 1.591.004.796-.313 1.421-.937 1.591zm-13.75 6.08a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.874 0z" fill="#9B9B9B" fill-rule="evenodd"/></svg>
      </button>
    </div>
  </li>
</template>

<script>
export default {
  name: 'CardItem',
  props: ['id', 'name', 'desc', 'like', 'dislike'],
  methods: {
    liked() {
      this.$store.commit('likeItem', this.id)
    },
    disliked() {
      this.$store.commit('dislikeItem', this.id)
    },
  },
}
</script>

<style scoped>
.card-item {
  border: 1px solid #ddd;
  border-radius: 2px;
  flex: 1 1 calc(33.333333% - 10px);
  margin: 5px;
  transition: 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 140px;
  overflow: hidden;
}

.card-item:hover {
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.1);
  cursor: default;
}

.name {
  margin: 15px 0 5px 0;
  padding: 0 10px;
}

.desc {
  margin: 0 0 15px 0;
  padding: 0 10px;
  font-size: 1em;
  color: #9b9b9b;
}

.liking {
  background-color: #ddd;
  margin-top: auto;
  display: flex;
  border-radius: 0 0 2px 2px;
  overflow: hidden;
}

button {
  outline: none;
}

button svg {
  transition: 0.2s;
}

button:hover svg {
  transform: scale(1.1);
}

button.like {
  border-left: 1px solid white;
}

button.like.active:disabled:hover,
button.like.active {
  background-color: #7ed321;
}

button.like.active svg path {
  fill: white;
}

button.dislike.active:disabled:hover,
button.dislike.active {
  background-color: #bd0e23;
}

button.dislike.active svg path {
  fill: white;
}
</style>



// WEBPACK FOOTER //
// src/components/CardItem.vue